/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate, Link } from 'react-router-dom'
import toast, { Toaster } from 'react-hot-toast'
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Modal,
  Row,
  Table
} from 'react-bootstrap'
import { Formik } from 'formik'
import { CreateStockOpnamePackingSchema } from '../../utils/validationSchema'
import Label from '../../components/Label/Input'
import TextField from '../../components/Input/TextInput'
import RowEmpty from '../../components/atoms/RowEmpty'
import { Search, Trash2 } from 'lucide-react'
import TablePagination from '../../components/atoms/Table/TablePagination'
import api from '../../config/AxiosInstance'
import ModalStockAdjustment from '../../components/modal/stockAdjustment/ModalStockAdjustment'
import { Loader } from 'react-bootstrap-typeahead'

const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '24px',
  fontWeight: '600'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const cardFilterStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

function StockOpnamePackingCreate() {
  const { state } = useLocation()
  const navigate = useNavigate()
  const debounceTimeout = useRef(null)
  const formikRef = useRef(null)
  const [show, setShow] = useState(false)
  const [visible, setVisible] = useState({
    cancel: false,
    create: false
  })
  const [searchItem, setSearchItem] = useState('')
  const abortControllerRef = useRef(null)
  const [selectedItems, setSelectedItems] = useState([])
  const [selectedItem, setSelectedItem] = useState([])
  const [loading, setLoading] = useState({
    submit: false
  })
  const [dataItems, setDataItems] = useState({
    data: [],
    isFetch: false,
    metaData: {
      per_page: 10,
      current_page: 1,
      total_row: 0,
      total_page: 0
    }
  })
  const columns = [
    { key: 'sequence', label: 'No' },
    { key: 'item_name', label: 'Item' },
    {
      key: 'sys_pack',
      label: 'Sys Pack',
      className: 'text-end',
      component: (item) => `${item.total_pack} ${item.uom_pack}`
    },
    {
      key: 'action',
      label: 'Action',
      className: 'text-end',
      component: (item) => (
        <div
          key={item.item_id}
          className="d-flex justify-content-end"
          onClick={() =>
            setSelectedItems(
              selectedItems.filter((value) => value.item_id !== item.item_id)
            )
          }
        >
          <Button variant="danger">
            <Trash2 size={14} />
          </Button>
        </div>
      )
    }
  ]
  const columnAddItems = [
    { key: 'checkbox', label: 'checkbox' },
    { key: 'item_name', label: 'Item' },
    { key: 'total_pack', label: 'Total Pack', className: 'text-end align-end' }
  ]
  const handleChangeCheckbox = (id) => {
    if (!id) {
      if (
        !selectedItem.length ||
        selectedItem.length !== dataItems.data.length
      ) {
        setSelectedItem(dataItems.data)
      } else {
        setSelectedItem([])
      }
    } else {
      const dataSelectedItem = dataItems.data.find(
        (item) => item.item_id === id
      )
      setSelectedItem((prevSelectedItem) => {
        if (prevSelectedItem.find((item) => item.item_id === id)) {
          return prevSelectedItem.filter((item) => item.item_id !== id)
        } else {
          return [...prevSelectedItem, dataSelectedItem]
        }
      })
    }
  }
  const handlePageChange = (data) => {
    setDataItems((prevData) => ({
      ...prevData,
      metadata: {
        ...prevData.metadata,
        page: data.selected + 1
      }
    }))
    window.scrollTo(0, 0)
  }
  const handleOnChangeMeta = (e) => {
    setDataItems((prevData) => ({
      ...prevData,
      metadata: {
        ...prevData.metadata,
        per_page: parseInt(e.target.value, 10)
      }
    }))
  }
  const getDataItems = async () => {
    try {
      setLoading((prevLoading) => ({ ...prevLoading, item: true }))
      const params = {
        warehouse_id: state?.warehouse_id || '',
        per_page: dataItems.metaData.per_page || 10,
        page: dataItems.metaData.current_page || 1,
        q: searchItem || ''
      }
      const response = await api.get('/opname-packing/items', { params })
      const { data, metadata } = response.data
      setDataItems((prevDataItems) => ({
        ...prevDataItems,
        data,
        isFetch: true,
        metaData: metadata
      }))
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: { fontSize: '14px', fontWeight: '600' }
      })
    } finally {
      setLoading((prevLoading) => ({ ...prevLoading, item: false }))
    }
  }
  const debouncedFetch = useCallback(() => {
    if (debounceTimeout.current) clearTimeout(debounceTimeout.current)

    debounceTimeout.current = setTimeout(() => {
      // Cancel the previous API request
      if (abortControllerRef.current) abortControllerRef.current.abort()

      // Create a new AbortController
      const controller = new AbortController()
      abortControllerRef.current = controller

      if (show) {
        getDataItems({ signal: controller.signal }).catch((err) => {
          if (err.name !== 'AbortError') console.error('API Error:', err)
        })
      }
    }, 1000)
  }, [
    show,
    searchItem,
    dataItems.metaData.current_page,
    dataItems.metaData.per_page
  ])
  const handleSearch = (value) => {
    setSearchItem(value)
    setDataItems((prevDataItems) => ({
      ...prevDataItems,
      metaData: { ...prevDataItems.metaData, current_page: 1 }
    }))
  }
  const handleSubmitAddItem = () => {
    const newSelectedItems = selectedItem.filter(
      (item) => !selectedItems.some((value) => value.item_id === item.item_id)
    )
    setSelectedItems([...selectedItems, ...newSelectedItems])
    setShow(false)
    setSelectedItem([])
  }
  useEffect(() => {
    debouncedFetch()
    return () => {
      if (debounceTimeout.current) clearTimeout(debounceTimeout.current)
      if (abortControllerRef.current) abortControllerRef.current.abort() // Cancel on unmount
    }
  }, [debouncedFetch])
  const handleSubmit = async (values) => {
    try {
      setLoading((prevLoading) => ({ ...prevLoading, submit: true }))
      const res = await api.post('/opname-packing', values)
      const { data } = res.data
      if (data) {
        toast.success('Stock Opname Packing created!', {
          position: 'top-right',
          style: { fontSize: '14px', fontWeight: '600' }
        })
        navigate('/stock-opname/packing-stock-opname', {
          state: {
            warehouse_id: state?.warehouse_id
          }
        })
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: { fontSize: '14px', fontWeight: '600' }
      })
    } finally {
      setLoading((prevLoading) => ({ ...prevLoading, submit: false }))
    }
  }
  const handleCloseModalCreateTicket = () => {
    const propertyVisible = Object.keys(visible).find(
      (key) => visible[key] === true
    )
    if (propertyVisible) {
      setVisible({ ...visible, [propertyVisible]: false })
    }
  }
  useEffect(() => {
    if (!state?.warehouse_id || !state?.selectedItems) {
      toast.error('Data not found', {
        position: 'top-right',
        style: { fontSize: '14px', fontWeight: '600' }
      })
      const { selectedItems, ...dataState } = state
      return navigate('/stock-opname/packing-stock-opname', {
        state: dataState
      })
    } else {
      setSelectedItems(state?.selectedItems || [])
    }
  }, [state])
  return (
    <Container>
      <Toaster />
      <Row>
        <Col
          md={12}
          className="d-flex justify-content-between align-items-start"
        >
          <div className="d-flex flex-column justify-content-start">
            <h4
              style={headerTitleStyle}
              className="d-flex align-items-center gap-2"
            >
              Create Packing Stock Opname
            </h4>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb fs-6">
                <li className="breadcrumb-item">
                  <Link
                    to="/stock-opname/packing-stock-opname"
                    state={{
                      warehouse_id: state?.warehouse_id
                    }}
                    className="text-decoration-none"
                  >
                    <span className="text-black fw-bold text-uppercase">
                      PACKING STOCK OPNAME
                    </span>
                  </Link>
                </li>
                <li
                  className="breadcrumb-item sj-item active"
                  aria-current="page"
                >
                  CREATE
                </li>
              </ol>
            </nav>
          </div>
        </Col>
      </Row>
      <Row>
        <Formik
          innerRef={formikRef}
          initialValues={{
            type: 'create',
            warehouse_id: state?.warehouse_id,
            notes: '',
            opname_id: null,
            items: selectedItems || []
          }}
          validateOnChange={true}
          validationSchema={CreateStockOpnamePackingSchema}
          onSubmit={(values) => {
            values.is_submited = false
            values.items = selectedItems.map((item) => ({
              id: null,
              item_id: item.item_id,
              item_name: item.item_name,
              total_pack: item.total_pack,
              checked_pack: null,
              status: null
            }))
            const { type, ...dataValues } = values
            handleSubmit(dataValues)
          }}
          enableReinitialize={true}
          initialTouched={{
            type: true,
            warehouse_id: true,
            notes: true,
            opname_id: true,
            items: true
          }}
          validateOnMount={true}
        >
          {({
            handleBlur,
            handleSubmit,
            handleChange,
            values,
            errors,
            touched,
            isValid,
            dirty
          }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <Card style={cardFilterStyle}>
                  <Row className="mb-3">
                    <Label
                      label="warehouse"
                      value={state.warehouse_name || ''}
                      col={12}
                    />
                    <TextField
                      label="note"
                      name="notes"
                      value={values.notes}
                      touched={touched}
                      errors={errors}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      col={12}
                      placeholder="Note..."
                    />
                  </Row>
                </Card>

                <Card style={cardFilterStyle}>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5
                      style={{
                        fontSize: '16px',
                        fontWeight: 'bold',
                        color: '#333'
                      }}
                    >
                      Items
                    </h5>
                    <Button
                      type="button"
                      className="btn-primary-blue"
                      size="sm"
                      onClick={() => setShow(true)}
                    >
                      <span className="fw-bold">+ Add Item</span>
                    </Button>
                  </div>

                  <Row>
                    <Table
                      responsive
                      hover
                      className="shadow-sm mb-3 bg-white"
                      size="sm"
                      style={{
                        fontSize: '14px',
                        marginBottom: 0,
                        borderRadius: '12px',
                        overflow: 'hidden'
                      }}
                    >
                      <thead style={{ backgroundColor: '#f8f9fa' }}>
                        <tr>
                          {columns.map((column) => (
                            <th
                              className={`p-2 align-middle ${column.className}`}
                              key={column.key}
                              style={tableHeaderStyle}
                            >
                              {column.key !== 'checkbox' && (
                                <span>{column.label}</span>
                              )}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {!selectedItems.length && (
                          <RowEmpty colSpan={columns.length} />
                        )}
                        {selectedItems.length > 0 &&
                          selectedItems.map((item, index) => (
                            <tr
                              key={index}
                              style={{ borderBottom: '1px solid #f0f0f0' }}
                            >
                              {columns.map((column) => (
                                <td
                                  key={column.key}
                                  className={`p-2 align-middle ${column.className}`}
                                >
                                  {column.key === 'sequence' && index + 1}
                                  {column.component && column.component(item)}
                                  {column.key !== 'action' &&
                                    !column.component &&
                                    !column.key.includes('checkbox') &&
                                    !column.key.includes('sequence') &&
                                    (item[column.key] ?? '-')}
                                </td>
                              ))}
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  </Row>
                </Card>
                <div className="d-flex justify-content-between gap-2 mt-3">
                  <Button
                    type="button"
                    variant="transparent"
                    style={{ fontWeight: '600' }}
                    onClick={() => setVisible({ ...visible, cancel: true })}
                  >
                    Cancel
                  </Button>
                  <Button
                    className={`${
                      isValid && !loading.submit
                        ? 'btn-primary-orange'
                        : 'btn-secondary opacity-25'
                    }`}
                    style={{ minWidth: '100px' }}
                    type="button"
                    disabled={loading.submit}
                    onClick={(e) => {
                      e.preventDefault()
                      setVisible({ ...visible, create: true })
                    }}
                  >
                    Create
                  </Button>
                </div>
              </Form>
            )
          }}
        </Formik>
      </Row>
      <ModalStockAdjustment
        show={show}
        onHide={() => {
          setShow(false)
          setSelectedItem([])
        }}
        title="Select Item"
        size="xl"
      >
        <Row className="mt-3" style={{ overflowY: 'auto', maxHeight: '70vh' }}>
          <div className="d-flex flex-row gap-2 my-2 justify-content-end">
            <InputGroup className="mb-3" style={{ width: '40%' }}>
              <Form.Control
                type="text"
                placeholder="Search"
                onChange={(e) => handleSearch(e.target.value)}
              />
              <InputGroup.Text>
                <Search size={14} />
              </InputGroup.Text>
            </InputGroup>
            <div>
              <Button
                className={`${
                  selectedItem.length > 0
                    ? 'btn-primary-orange'
                    : 'btn-secondary opacity-25'
                }`}
                disabled={!selectedItem.length}
                onClick={handleSubmitAddItem}
              >
                Submit
              </Button>
            </div>
          </div>
          <Table
            responsive
            hover
            className="shadow-sm mb-5 bg-white rounded"
            size="sm"
            style={{ fontSize: '14px' }}
          >
            <thead className="table-secondary">
              <tr>
                {columnAddItems.map((columnAddItem) => (
                  <th
                    className={`align-middle p-2 ${columnAddItem.className}`}
                    key={columnAddItem.key}
                  >
                    {columnAddItem.key === 'checkbox' && (
                      <input
                        type="checkbox"
                        className="staging-area form-check-input"
                        checked={
                          dataItems.data?.length !== 0 &&
                          (dataItems.data.length === selectedItem.length ||
                            dataItems.data.length === selectedItems.length)
                        }
                        disabled={
                          !dataItems.data?.length ||
                          dataItems.data.every((value) =>
                            selectedItems.some(
                              (valueItem) => valueItem.item_id === value.item_id
                            )
                          )
                        }
                        onChange={() => handleChangeCheckbox()}
                        role="button"
                      />
                    )}
                    {columnAddItem.key !== 'checkbox' && (
                      <span>{columnAddItem.label}</span>
                    )}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {(loading.item || !dataItems.isFetch) && (
                <tr>
                  <td
                    colSpan={columnAddItems.length}
                    className="p-2 text-center"
                  >
                    <Loader />
                  </td>
                </tr>
              )}
              {!loading.item &&
                !dataItems.data?.length &&
                dataItems.isFetch && <RowEmpty colSpan={columns.length} />}
              {!loading.item &&
                dataItems.data?.length > 0 &&
                dataItems.isFetch &&
                dataItems.data?.map((item, index) => (
                  <tr key={index}>
                    {columnAddItems.map((column) => (
                      <td
                        key={column.key}
                        className={`align-middle p-2 ${column.className}`}
                      >
                        {column.key === 'checkbox' && (
                          <input
                            type="checkbox"
                            className="add-item-adjustment form-check-input"
                            value={item?.item_id}
                            checked={
                              selectedItem.some(
                                (itemSelected) =>
                                  itemSelected.item_id === item.item_id
                              ) ||
                              selectedItems.some(
                                (itemSelected) =>
                                  itemSelected.item_id === item.item_id
                              )
                            }
                            disabled={selectedItems.some(
                              (itemSelected) =>
                                itemSelected.item_id === item.item_id
                            )}
                            onChange={() => handleChangeCheckbox(item?.item_id)}
                            role="button"
                          />
                        )}
                        {column.component && column.component(item)}
                        {column.key !== 'action' &&
                          !column.component &&
                          !column.key.includes('checkbox') &&
                          (item[column.key] ?? '-')}
                      </td>
                    ))}
                  </tr>
                ))}
            </tbody>
            <tfoot>
              <tr>
                <td className="p-2" colSpan={columnAddItems.length}>
                  <TablePagination
                    meta={dataItems.metaData}
                    handlePageChange={handlePageChange}
                    handleOnChangeMeta={handleOnChangeMeta}
                  />
                </td>
              </tr>
            </tfoot>
          </Table>
        </Row>
      </ModalStockAdjustment>
      <ModalStockAdjustment
        show={Object.values(visible).includes(true)}
        onHide={handleCloseModalCreateTicket}
        title=""
        size="md"
      >
        <div className="p-2 mt-3 text-center">
          <div className="d-flex justify-content-center">
            <svg
              width="181"
              height="180"
              viewBox="0 0 181 180"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M90.5 0C40.7991 0 0.5 40.2991 0.5 90C0.5 139.701 40.7991 180 90.5 180C140.201 180 180.5 139.701 180.5 90C180.5 40.2991 140.201 0 90.5 0ZM90.5 164.732C49.2366 164.732 15.7679 131.263 15.7679 90C15.7679 48.7366 49.2366 15.2679 90.5 15.2679C131.763 15.2679 165.232 48.7366 165.232 90C165.232 131.263 131.763 164.732 90.5 164.732Z"
                fill="#828282"
              />
              <path
                d="M80.8574 125.357C80.8574 127.915 81.8734 130.367 83.6817 132.176C85.4901 133.984 87.9428 135 90.5003 135C93.0577 135 95.5104 133.984 97.3188 132.176C99.1272 130.367 100.143 127.915 100.143 125.357C100.143 122.8 99.1272 120.347 97.3188 118.539C95.5104 116.73 93.0577 115.714 90.5003 115.714C87.9428 115.714 85.4901 116.73 83.6817 118.539C81.8734 120.347 80.8574 122.8 80.8574 125.357ZM85.6789 102.857H95.3217C96.2056 102.857 96.9289 102.134 96.9289 101.25V46.6071C96.9289 45.7232 96.2056 45 95.3217 45H85.6789C84.7949 45 84.0717 45.7232 84.0717 46.6071V101.25C84.0717 102.134 84.7949 102.857 85.6789 102.857Z"
                fill="#828282"
              />
            </svg>
          </div>
          <div className="my-3">
            {visible.cancel && (
              <>
                <h6>Cancel?</h6>
                <p>All data will be deleted, cancel creating ticket?</p>
              </>
            )}
            {visible.create && (
              <>
                <h6>Create?</h6>
                <p>Make sure all data is correct!</p>
              </>
            )}
          </div>
          <Modal.Footer className="mt-4">
            <div className="d-flex flex-column align-items-end justify-content-end h-100 mt-3">
              <div className="d-flex gap-2">
                {visible.cancel && (
                  <>
                    <Button
                      variant="transparent"
                      onClick={handleCloseModalCreateTicket}
                    >
                      Continue Creating
                    </Button>
                    <Button
                      className="btn-primary-orange"
                      onClick={() => {
                        navigate('/stock-opname/packing-stock-opname', {
                          replace: true,
                          state: {
                            warehouse_id: state?.warehouse_id || ''
                          }
                        })
                      }}
                    >
                      Cancel
                    </Button>
                  </>
                )}
                {visible.create && (
                  <>
                    <Button
                      variant="transparent"
                      onClick={handleCloseModalCreateTicket}
                    >
                      Cancel
                    </Button>
                    <Button
                      className={`${
                        loading.submit
                          ? 'btn-secondary opacity-25'
                          : 'btn-primary-orange'
                      }`}
                      onClick={() => formikRef.current?.submitForm()}
                      disabled={loading.submit}
                    >
                      {loading.submit ? 'Creating...' : 'Create Ticket'}
                    </Button>
                  </>
                )}
              </div>
            </div>
          </Modal.Footer>
        </div>
      </ModalStockAdjustment>
    </Container>
  )
}
export default StockOpnamePackingCreate
